app.controller('BrowseRangeInfoSolutionController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    let i, choice, siteRange, siteRangeID;
    const navigationIDs = $scope.navigation_ids;
    const solutionID = navigationIDs.solution_id;
    const assemblyID = navigationIDs.assembly_id;

    const variationIDs = {browse_id: "solution", solution_id: solutionID}

    if (assemblyID) {
        variationIDs.assembly_id = assemblyID;
    }

    const siteRangeModel = $rootScope.factory.site_range.clonedModel(variationIDs);
    const siteRangeList = siteRangeModel.choiceList();

    const siteRangeIDs = {};

    $scope.info_model = $rootScope.factory.info.getModel(navigationIDs);

    for (i = 0; i < siteRangeList.length; i++) {
        siteRange = siteRangeList[i];
        siteRangeIDs[siteRange.id] = true;
    }

    const colourModels = {};
    const styleModels = {};
    const validSiteRangeIDs = {};
    let bellaStyleList = [];
    let doorColourCount = 0;
    for (siteRangeID in siteRangeIDs) {
        variationIDs.site_range_id = siteRangeID;
        const colourModel = $rootScope.factory.colour.getModel(variationIDs);
        const styleModel = $rootScope.factory.style.getModel(variationIDs);
        colourModels[siteRangeID] = colourModel;
        styleModels[siteRangeID] = styleModel;
        if (siteRangeID === "bella") {
            bellaStyleList = styleModel.choiceList();
        }
        const colourChoiceList = colourModel.choiceList();
        for (i = 0; i < colourChoiceList.length; i++) {
            const colour = colourChoiceList[i];
            if (colour.site_range_id) {
                validSiteRangeIDs[colour.site_range_id] = true;
                doorColourCount++;
            }
        }
    }

    delete variationIDs.site_range_id;

    const siteRangeColours = {};
    for (i = 0; i < siteRangeList.length; i++) {
        siteRange = siteRangeList[i];
        if (!validSiteRangeIDs[siteRange.id]) {
            siteRangeList.splice(i, 1);
            i--;
            continue
        }
        siteRangeColours[siteRange.id] = colourModels[siteRangeID].choiceList();
    }


    variationIDs.option_id = "clicbox_colour";

    const clicboxColourModel = $rootScope.factory.option_term.getModel(variationIDs);

    delete variationIDs.option_id;

    const fromChoiceList = clicboxColourModel.choiceList();
    const clicboxColourChoiceList = [];

    for (i = 0; i < fromChoiceList.length; i++) {
        choice = fromChoiceList[i];
        if (!choice.disabled) {
            clicboxColourChoiceList.push(choice);
        }
    }

    $scope.door_colour_count = doorColourCount;
    $scope.clicbox_colour_choice_list = clicboxColourChoiceList;
    $scope.range_list = siteRangeList;
    $scope.bella_style_list = bellaStyleList;
    $scope.range_colours = siteRangeColours;

    $scope.printRangeNames = function (delimiter) {
        const rangeList = $scope.range_list;
        let text = "";
        for (let i = 0; i < rangeList.length; i++) {
            const choice = rangeList[i];
            if (i !== 0) {
                if (i === rangeList.length - 1) {
                    text += " " + (delimiter ? delimiter : "&") + " ";
                } else {
                    text += ", ";
                }
            }

            text += choice.name;
        }
        return text;
    }

    $scope.printColourCountRangeNames = function (delimiter) {
        const rangeList = $scope.range_list;
        let text = "";
        for (let i = 0; i < rangeList.length; i++) {
            const choice = rangeList[i];
            const colourCount = $scope.range_colours[choice.id] ? $scope.range_colours[choice.id].length : 0;
            if (i !== 0) {
                if (i === rangeList.length - 1) {
                    text += " " + (delimiter ? delimiter : "&") + " ";
                } else {
                    text += ", ";
                }
            }

            text += colourCount + " " + choice.name;
        }
        return text;
    }

    $scope.printClicboxNameCodes = function () {
        let text = "";
        for (let i = 0; i < clicboxColourChoiceList.length; i++) {
            const choice = clicboxColourChoiceList[i];
            const code = $scope.clicboxCode(choice.id);
            const nameCode = choice.name + (code ? " " + code : "");
            if (i !== 0) {
                if (i === clicboxColourChoiceList.length - 1) {
                    text += " and ";
                } else {
                    text += ", ";
                }
            }

            text += nameCode;
        }
        return text;
    }

    $scope.clicboxCode = function (clicboxColourID) {
        switch (clicboxColourID) {
            case "white":
                return "Kronospan K101";
            case "urban_oak":
                return "Kronospan K005";
            case "grey":
                return "Kronospan 0112";
            case "anthracite":
                return "Kronospan 0164";
            default:
                return "";
        }
    }

    $scope.rangeHref = function (range) {
        const routeIDs = {
            browse_id: "solution",
            solution_id: solutionID,
            site_range_id: range.id
        }
        if (solutionID !== "bedroom_flat_pack") {
            routeIDs.room_id = "kitchen";
        } else {
            routeIDs.room_id = "bedroom";
            routeIDs.door_type_id = "hinged";
        }
        return $rootScope.navigation_manager.createNavigationModel(null, routeIDs, true).href;
    }

    $scope.product_documents = [];
    let rangeInfoTag = null;
    switch (solutionID) {
        case "kitchen_rigid_flat_pack":
            rangeInfoTag = "flat_pack_kitchen";
            break
        case "kitchen_inrail":
            rangeInfoTag = "true_handleless_rigid_kitchen";
            break
        case "bedroom_flat_pack":
            rangeInfoTag = "flat_pack_bedroom";
            break
        default:
            break
    }
    if (rangeInfoTag) {

        $rootScope.service.cache_local_server.productDocumentsByTags(["range_info", rangeInfoTag], function (documents) {

            documents = JSON.parse(JSON.stringify(documents));
            for (let i = 0; i < documents.length; i++) {
                const document = documents[i];
                document.is_range_generic = false;
                if (document.product_tags) {
                    if (document.product_tags.range_generic) {
                        document.is_range_generic = true;
                    }
                }
            }

            documents.sort(function (a, b) {
                if (!a.is_range_generic && b.is_range_generic) {
                    return -1;
                }
                if (a.is_range_generic && !b.is_range_generic) {
                    return 1;
                }
            })
            $scope.product_documents = documents;
        })
    }

}]);